import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";
import type { TextVariant } from "@/components/atoms/types";
import { ifWeb } from "@/utils/platform";

/**
 *
 */
interface Props {
  title?: string;
  description?: string;
  isDark?: boolean;
}

/**
 * View component for empty reports list state
 * @param root0 - Component props
 * @param root0.title - Title text to display in the empty state
 * @param root0.description - Description text providing additional context
 * @param root0.isDark - Whether to use dark theme colors for text
 */
const ListEmptyView = ({
  title = "No Similar Players",
  description = "We could not find any similar players for this player.",
  isDark: _isDark,
}: Props) => (
  <Stack className="size-full items-center justify-center gap-3">
    <Text
      variant={ifWeb<TextVariant>("title-sm", "display-sm")}
      className="text-center"
    >
      {title}
    </Text>
    <Text
      variant="unstyled"
      className={`text-center font-medium ${ifWeb("text-body", "text-title-sm")} text-content-muted`}
    >
      {description}
    </Text>
  </Stack>
);

ListEmptyView.displayName = "ListEmptyView";

export default memo(ListEmptyView);
